module.exports = __webpack_public_path__ + "img/kuan_normal.ca0fe05d.png";